
import React, { Component } from 'react';
import UrlServer from "configs/UrlServer"
import { APIPost, APIGet } from "services/APIRequest"
import * as Alert from "alertService"
import Highcharts from 'highcharts'
import variablePie from "highcharts/modules/variable-pie.js";
variablePie(Highcharts);

class Chart2 extends Component {
	constructor() {
		super();
		this.state = {
			data: null
		}
	}
	componentDidMount() {
		Alert.Loading(true)
		var where = {}
		if (this.props.selected_dealer) {
			where.dealer_code = [this.props.selected_dealer]
		}
		APIPost(UrlServer.URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD2_1R, where, ({ datas }) => {
			this.setState({
				data: datas
			}, () => {
				Alert.LoadingClose()
				this.setChart(datas)
			})
		})


	}
	cleanValue = (val, qtr_num, ispass = true) => {
		var res = 0
		if (ispass) {
			res = val[qtr_num].sum_is_pass_per
		} else {
			res = val[qtr_num].sum_is_not_pass_per
		}
		return Math.round(res)
	}
	setChart(datas) {
		const colors = ['#67b6ff', '#dd0000'];
		const categories = ['Quarter 2/FY21', 'Quarter 3/FY21', 'Quarter 4/FY21', 'Quarter 1/FY21']
		var series = [{
			name: 'Higher than NPS',
			data: [this.cleanValue(datas, "qtr2"), this.cleanValue(datas, "qtr3"), this.cleanValue(datas, "qtr4"), this.cleanValue(datas, "qtr1")]
		}, {
			name: 'Lower than NPS',
			data: [this.cleanValue(datas, "qtr2", false), this.cleanValue(datas, "qtr3", false), this.cleanValue(datas, "qtr4", false), this.cleanValue(datas, "qtr1", false)]
		}]
		Highcharts.chart('chart_3_2', {
			chart: {
				type: 'bar'
			},
			title: {
				text: 'Pass % NPS-OS'
			},
			colors: colors,
			xAxis: {
				categories: categories
			},
			yAxis: {
				min: 0,
				max: 100,
				title: {
					text: ''
				}
			},
			legend: {
				reversed: true
			},
			plotOptions: {
				series: {
					stacking: 'normal'
				},
				bar: {
					dataLabels: {
						enabled: true,
						style: {
							textOutline: 0
						},
					}

				}
			},
			series: series
		});
	}
	render() {
		return (
			<div className={"chart-box"}>
				<center>
					<div id="chart_3_2" style={{ width: "92%", height: "350px" }}></div>
				</center>
			</div>
		);
	}
}

export default Chart2;